export default __webpack_public_path__ + "static/media/Youth-Programs-cap60.7ba217a9.jpeg";